import { render } from "./checkboxTemplate.vue?vue&type=template&id=cfdf5fa0&scoped=true&ts=true"
import script from "./checkboxTemplate.vue?vue&type=script&lang=ts"
export * from "./checkboxTemplate.vue?vue&type=script&lang=ts"

import "./checkboxTemplate.vue?vue&type=style&index=0&id=cfdf5fa0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cfdf5fa0"]])

export default __exports__